import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPreview() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setArticles(r.data.slice(0, 3))).catch(() => setArticles([]));
  }, []);

  return (
    <section id="articles" data-testid="blog-preview-section" className="section">
      <div className="container-page">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-8">
            <p className="label-eyebrow">Health Notes</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest mt-5 leading-[1.05]">
              Articles to read <span className="italic text-terracotta">at your own pace.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Link to="/articles" data-testid="see-all-articles" className="btn-outline h-12 text-sm">
              All Articles <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {articles.map((a, i) => (
            <Link
              key={a.slug}
              to={`/articles/${a.slug}`}
              data-testid={`blog-card-${a.slug}`}
              className="card-soft overflow-hidden group block"
              style={{ animation: `fade-up 0.7s ease-out ${i * 80}ms both` }}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={a.cover} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-sage">
                  <span>{a.category}</span>
                  <span className="w-1 h-1 rounded-full bg-sage/50" />
                  <span>{a.read_minutes} min read</span>
                </div>
                <h3 className="font-serif text-2xl md:text-[26px] leading-tight text-forest mt-4 group-hover:text-terracotta transition-colors">{a.title}</h3>
                <p className="mt-3 text-forest/70 leading-relaxed line-clamp-3">{a.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
